import React from 'react';
import { Layout } from '@/components/layout/Layout';

export default function TermsPage() {
  return (
    <Layout>
      <div className="py-24 px-6 max-w-4xl mx-auto">
        <h1 className="text-4xl font-serif text-foreground mb-8">Termini di Servizio</h1>
        <div className="bg-card border border-primary/10 rounded-sm p-8 text-muted-foreground leading-relaxed space-y-4">
          <p>
            Artisan Pizza Talent offre un servizio di intermediazione tra professionisti del settore pizza e ristoratori.
          </p>
          <p>
            I ristoratori si impegnano a non contattare i candidati presentati in forma privata per un periodo di 12 mesi dalla presentazione.
          </p>
          <p>
            La commissione di mediazione è dovuta solo a seguito dell'assunzione del candidato, secondo gli accordi privati definiti tra le parti prima del colloquio.
          </p>
        </div>
      </div>
    </Layout>
  );
}